<script>
  import { layoutMethods,eventListMethods,eventsComputed, erpUserRolesMethods  } from "@/state/helpers";
  import EventItem from './EventItem';
  import Swal from "sweetalert2";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Event List component
   */
  export default {
    page: {
      title: "Event List"
    },
    components: {
      EventItem
    },
    computed: {
      ...eventsComputed
    },
    data() {
      return {
        title: "Event list",
        pageOptions: [6, 12, 18, 24, 30, 36, 42, 48, 54, 60],
        pagination: {
          rows: 6,
          page: 1,
          search: null,
          searchField: null
        },
        searchOptions: [
          {text: 'Search All', value:null},
          {text: 'Event Name', value:'name'},
          {text: 'Event Description', value:'description'},
        ],
        eventsModule: {
          access: {
            create: true,
            read: true,
            update: true,
            delete: true
          }
        } 
      };
    },
    methods: {
      ...layoutMethods,
      ...eventListMethods,
      ...erpUserRolesMethods,
      loadEvents(state = ''){
        if(state == 'reset'){
          this.pagination.page = 1;
        }
        // var list_res = {};
        this.eventList(this.pagination)
        .then(function(res){
          console.log("check:",res);
          // list_res = res;
          // this.eventTotalRows = res.pageInfo.total;
        })
        .catch(function(e){
            Swal.fire("Loading Failed!", `${e}`, "error");
        });
        // this.events = Object.prototype.hasOwnProperty.call(list_res, "rows") ?  list_res.rows : [];
        // this.eventTotalRows = Object.prototype.hasOwnProperty.call(list_res, "pageInfo") ? list_res.pageInfo.total : 0;
        // console.log(this.events, this.eventTotalRows);
      },
      editEvent(event){
        console.log(">> EDIT:", event);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Add Event", params: { id: event.id }
          }
        );
      },
      deleteEvent(event){
        if (!this.eventsModule.access.delete) {
          Swal.fire(
            "Access Restricted",
            "You are not allowed to delete an Event.",
            "warning"
          );
        } else {
          Swal.fire({
              title: 'Are you sure?',
              text: `Do you really want to delete ${event.name}? This process cannot be undone.`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                // alert("do delete feature");
                this.deleteEventItem(event.id)
                .then(() => {
                  Swal.fire("Delete Successful!", `${event.name} has been deleted.`, "success");
                  this.loadEvents();
                })
                .catch((e) => {
                  Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "danger");
                });
              }else{
                  return;
              }
          })
          console.log(">> DELETE:", event);
        }
      },
      onDisplayChange(){
        console.log(this.eventTotalRows,this.pagination.rows,this.events.length,(this.events.length < this.eventTotalRows && this.events.length != this.pagination.rows));
        if(
          (this.events.length < this.eventTotalRows && this.events.length != this.pagination.rows) || // condition for incrementing display per page
          (this.events.length == this.eventTotalRows && this.pagination.rows < this.events.length) // condition for decreasing display per page
          ){
          this.pagination.page=1;
          this.loadEvents()
        }
      },
      refresh(){
        // this.pagination= {
        //   rows: 6,
        //   page: 1,
        //   search: null,
        //   searchField: null
        // }
        this.loadEvents();
      },
      viewEvent(event){
        console.log(">> view:", event);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Event Details", params: { id: event.id }
          }
        );
      },
    },
    async mounted(){
      this.changeTitle({title: 'Event List'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Event List', to: { name: 'Event List'} }
        ]
      });
      this.loadEvents();

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Utilities', 'Events')
        .then((access) => this.eventsModule.access = access);

    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <div class="row">
          <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="row mb-3">
                        <div class="col-md-4 col-sm-4">
                            <div class="my-2">
                                <h5 class="card-title text-dark">
                                    <span class="fw-normal ms-lg-2"> {{eventTotalRows}} </span> Record(s)
                                </h5>
                            </div>
                        </div>
                        <!-- end col record display--> 
                        <div class="col-sm-5 ta-right">
                            <b-form-group description="Search Keyword">
                              <form class="d-flex"  @submit.prevent="loadEvents('reset')" >
                                <b-form-group id="input-group-3" label-for="input-3">
                                  <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
                                    id="input-3"
                                    v-model="pagination.searchField"
                                    :options="searchOptions"
                                  ></b-form-select>
                                </b-form-group>

                                <b-input-group>
                                  <b-form-input v-model="pagination.search" class="rounded-0"></b-form-input>
                                  <b-input-group-append>
                                    <b-button variant="primary" type="submit" class="rounded-0 rounded-end px-2">
                                      <i class='bx bx-search bx-fw'></i>
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                              </form>
                            </b-form-group>
                        </div>
                        <div class="col-md-3 col-sm-3"> 
                            <div class="d-flex justify-content-lg-end mb-lg-3">
                                <router-link v-if="eventsModule.access.create" :to="{ name: 'Add Event', params: { id: 0 }}" class="tc-white me-2">
                                  <button class="btn btn-primary" >
                                      <i class="uil uil-plus me-1"></i> Add Event
                                  </button>
                                </router-link>

                                <a class="btn btn-secondary" @click="refresh()">
                                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather> Refresh
                                </a>
                            </div>
                        </div>
                        <!-- end col menus -->
                    </div>
                    <!-- end row -->

                    <template>
                      <div class="row">
                        <event-item
                          v-for="(event, index) in events" 
                          v-bind:key="index"
                          v-bind:event="event"
                          @edit="editEvent(event)"
                          @delete="deleteEvent(event)"
                          @view="viewEvent(event)"
                          />
                      </div>
                    </template><!--end of template item-->
                    <div class="row g-0 text-center" v-if="eventTotalRows == 0">
                      <span>No data to display.</span>
                    </div>
                    <div class="row g-0 text-center text-sm-start">
                      <!-- end col -->
                      <div class="col-sm-12"  v-if="eventTotalRows != 0 && eventTotalRows > 6">
                        <div class="row">
                          <div class="col">
                            <div class="form-group row pull-left">
                              <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                              <div class="col-sm-6">
                                <b-form-group label-for="display-record">
                                  <b-form-select class="form-select shadow-none w-fit"
                                    id="display-record"
                                    v-model="pagination.rows"
                                    :options="pageOptions"
                                    @change="onDisplayChange()"
                                  ></b-form-select>
                                </b-form-group>
                              </div>
                            </div>
                            <div
                              class="
                                dataTables_paginate
                                paging_simple_numbers
                                float-end
                              "
                            >
                              <!-- pagination -->
                              <b-pagination  v-if="eventTotalRows != 0 && eventTotalRows > 6 && eventTotalRows > pagination.rows"
                                class="pagination-rounded"
                                v-model="pagination.page"
                                @input="loadEvents"
                                :total-rows="eventTotalRows"
                                :per-page="pagination.rows"
                              ></b-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- end col -->
                    </div>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>